import { useState } from 'react'
import { Outlet, NavLink, useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import {
  HiOutlineHome,
  HiOutlineOfficeBuilding,
  HiOutlineUsers,
  HiOutlineLogout,
  HiOutlineMenu,
  HiOutlineX,
  HiOutlineMail,
  HiOutlineQrcode,
} from 'react-icons/hi'
import toast from 'react-hot-toast'

const navItems = [
  { to: '/', icon: HiOutlineHome, label: 'Dashboard' },
  { to: '/agencies', icon: HiOutlineOfficeBuilding, label: 'Agencies' },
  { to: '/agency-requests', icon: HiOutlineMail, label: 'Agency Requests' },
  { to: '/users', icon: HiOutlineUsers, label: 'Users' },
  { to: '/qr-code', icon: HiOutlineQrcode, label: 'QR Generator' },
]

export default function AdminLayout() {
  const { profile, profileLoading, roleName, signOut, getDisplayName } = useAuth()
  const navigate = useNavigate()
  const [sidebarOpen, setSidebarOpen] = useState(false)

  const handleSignOut = async () => {
    try {
      await signOut()
      navigate('/login')
      toast.success('Signed out successfully')
    } catch {
      toast.error('Failed to sign out')
    }
  }

  return (
    <div className="admin-layout">
      {/* Mobile overlay */}
      {sidebarOpen && (
        <div
          className="sidebar-overlay"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <div className="logo">
            <div className="logo-icon">K</div>
            <span className="logo-text">Kleezy</span>
          </div>
          <button
            className="sidebar-close"
            onClick={() => setSidebarOpen(false)}
          >
            <HiOutlineX />
          </button>
        </div>

        <nav className="sidebar-nav">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) =>
                `nav-item ${isActive ? 'active' : ''}`
              }
              onClick={() => setSidebarOpen(false)}
            >
              <item.icon className="nav-icon" />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="sidebar-footer">
          <div className="user-info">
            <div className="user-avatar">
              {profile?.first_name?.charAt(0) || profile?.email?.charAt(0) || 'A'}
            </div>
            <div className="user-details">
              <span className="user-name">
                {getDisplayName()}
              </span>
              <span className="user-role">
                {profileLoading && !roleName ? 'loading role' : roleName}
              </span>
            </div>
          </div>
          <button
            className="logout-btn"
            onClick={handleSignOut}
            title="Sign out"
          >
            <HiOutlineLogout />
          </button>
        </div>
      </aside>

      {/* Main content */}
      <div className="main-content">
        <header className="topbar">
          <button
            className="menu-toggle"
            onClick={() => setSidebarOpen(true)}
          >
            <HiOutlineMenu />
          </button>
          <div className="topbar-right">
            <span className="topbar-greeting">
              Welcome, <strong>{getDisplayName()}</strong>
            </span>
          </div>
        </header>

        <main className="page-content">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
